import { render, staticRenderFns } from "./UnitInput.vue?vue&type=template&id=2f4fa852&scoped=true&"
import script from "./UnitInput.vue?vue&type=script&lang=js&"
export * from "./UnitInput.vue?vue&type=script&lang=js&"
import style0 from "./UnitInput.vue?vue&type=style&index=0&id=2f4fa852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4fa852",
  null
  
)

component.options.__file = "UnitInput.vue"
export default component.exports